if (!customElements.get('twa-action-library')) {
  customElements.define(
    'twa-action-library',
    class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const filters = this.querySelector('.twa-action__filters');
        filters.hidden = false;
        filters.addEventListener(
          'click',
          (event) => {
            const button = event.target.closest('[data-filter]');
            if (!button) return;
            filters
              .querySelectorAll('button')
              .forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
            this.querySelectorAll('[data-category]').forEach((card) => {
              card.hidden = button.dataset.filter !== '0' && button.dataset.filter !== card.dataset.category;
            });
            this.querySelectorAll('[data-video-group]').forEach((group) => {
              group.hidden = !group.querySelector('[data-category]:not([hidden])');
            });
            const count = this.querySelectorAll('[data-category]:not([hidden])').length;
            this.querySelector('[data-status]').textContent = `${count} ${count === 1 ? 'video' : 'videos'} shown`;
          },
          { signal: this.abort.signal },
        );
      }
      disconnectedCallback() {
        this.abort?.abort();
      }
    },
  );
}
